module.exports = __webpack_public_path__ + "img/app2.d8f618e.png";